'use strict'

function welcome() {
  if (!$.cookie('properties_welcome_modal')) {
    $.cookie('properties_welcome_modal', true, { expires: 7 })
    $('#properties_welcome_modal').modal('show')
  }
}

jQuery(function ($) {
  welcome()
})
